import React, { lazy } from 'react'
const LoginPage = lazy(() => import('./LoginPage'))
const PasswordRecoveryPage = lazy(() => import('./PasswordRecoveryPage'))
const PasswordResetPage = lazy(() => import('./PasswordResetPage'))
const SignupPage = lazy(() => import('./SignupPage'))
const SignupConfirmationPage = lazy(() => import('./SignupConfirmationPage'))
const SignupSuccessfulPage = lazy(() => import('./SignupSuccessfulPage'))

const AuthorizationRouting = [
  {
    element: <LoginPage />,
    path: 'login',
    public: true,
  },
  {
    element: <PasswordRecoveryPage />,
    path: 'password-recovery',
    public: true,
  },
  {
    element: <PasswordResetPage />,
    path: 'password-reset',
    public: true,
  },
  {
    element: <SignupPage />,
    path: 'signup',
    public: true,
  },
  {
    element: <SignupSuccessfulPage />,
    path: 'signup-successful',
    public: true,
  },
  {
    element: <SignupConfirmationPage />, // code uuid
    path: 'registration/confirm',
    public: true,
  },
]
export default AuthorizationRouting
